import processCalcSkillsHarness from '../processes/processCalcSkillsHarness'

import trackCharacteristicChanges from '../helpers/trackCharacteristicChanges'
import calcCharacteristicValues from '../helpers/calcCharacteristicValues'
import isAbilityCharacteristic from '../helpers/isAbilityCharacteristic'
import calcGeneralDetails from '../helpers/calcGeneralDetails'
import calcAbilities from '../helpers/calcAbilities'

import store from '../store/index'
//-------------------------------
// process characteristic change
//-------------------------------
export default function processCharacteristicChange({
  pfx,
  original_chars,
  changed_chars,
  isNewCharacterLoad,
  character,
}) {
  console.log('------------------------')
  console.log('IN processCharacteristicChange')
  console.log('pfx = ' + pfx)
  //--------------------------
  // get max skill from store
  //--------------------------
  const max_skill = store.state.combat.config.max_skill
  //----------------------------
  // calc characteristic values
  //----------------------------
  character = calcCharacteristicValues({ pfx, character })
  //----------------
  // calc abilities
  //----------------
  if (isAbilityCharacteristic(pfx)) {
    character = calcAbilities({ pfx, character })
  }
  //----------------------
  // calc general details
  //----------------------
  character = calcGeneralDetails({ character })
  //-------------
  // calc skills
  //-------------
  character = processCalcSkillsHarness({ pfx, character, max_skill })
  //----------------------------------------------------------------
  // track characteristic changes (where not new char initial load)
  //----------------------------------------------------------------
  if (!isNewCharacterLoad) {
    changed_chars = trackCharacteristicChanges({
      pfx,
      character,
      original_chars,
      changed_chars,
    })
    // console.log('MMMMM this.changed_chars = ', this.changed_chars)
  }
  return { character, changed_chars }
}
